import type { AvatarProps as MUIAvatarProps } from '@material-ui/core'
import { Avatar as MUIAvatar, useTheme } from '@material-ui/core'
import React from 'react'
import Tooltip from '../Tooltip'

export interface AvatarProps extends MUIAvatarProps {
  tooltip?: React.ReactNode
  avatarColor?: string
  backgroundColor?: string
  width?: string
  height?: string
  fontSize?: string
  oneLetter?: boolean
  disableTooltip?: boolean
  filled?: boolean
  noTransform?: boolean
}

export default function Avatar(props: AvatarProps) {
  const theme = useTheme()

  const { children: _children, tooltip, avatarColor = null, disableTooltip, filled, noTransform, ...otherProps } = props
  let children
  const style = {} as any
  let alt
  if (typeof _children === 'string') {
    if (props.oneLetter) {
      children = _children[0]
    } else {
      children = _children
        .split(' ')
        .map((s) => {
          return s[0]
        })
        .join('')
    }

    const backgroundColor = avatarColor ?? generateColor(_children)
    style.boxShadow = `0px 0px 0px 2px ${backgroundColor}`
    style.backgroundColor = props.backgroundColor ?? 'transparent'
    style.height = props.height ?? '30px'
    style.width = props.width ?? '30px'
    style.fontSize = props.fontSize ?? '15px'
    style.paddingTop = '2px'
    style.paddingLeft = props.oneLetter ? 0 : '1px'
    style.borderRadius = '999em'
    const color = avatarColor ?? theme.palette.common.black
    style.color = color
    style.transform = 'translateZ(0)'

    if (filled) {
      style.backgroundColor = backgroundColor
      style.color = theme.palette.getContrastText(backgroundColor)
      style.boxShadow = 'none'
      style.transform = 'translateZ(0) scale(1.2)'
    }

    if (noTransform) {
      style.transform = 'translateZ(0)'
    }

    alt = _children
  } else {
    children = _children
  }

  if (disableTooltip) {
    return (
      <MUIAvatar {...otherProps} style={{ ...style, ...props.style }} alt={alt}>
        {children}
      </MUIAvatar>
    )
  }

  const _tooltip = tooltip ? <div style={{ whiteSpace: 'pre' }}>{tooltip}</div> : null

  return (
    <Tooltip content={_tooltip ? _tooltip : _children} hideIcon placement="right">
      <MUIAvatar {...otherProps} style={style} alt={alt}>
        {children}
      </MUIAvatar>
    </Tooltip>
  )
}

function getHashOfString(str: string) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  hash = Math.abs(hash)
  return hash
}

function normalizeHash(hash: number, min: number, max: number) {
  return Math.floor((hash % (max - min)) + min)
}

function generateColor(str: string) {
  const hash = getHashOfString(str)
  const h = normalizeHash(hash, 0, 360)
  // const h = Math.random() * 360
  const s = normalizeHash(hash, 0, 100)
  // const s = '56'
  const l = normalizeHash(hash, 0, 100)
  // const l = '37'

  return `hsl(${h}, ${s}%, ${l}%)`
}
